import { studentUpdateApi } from "../../api/student/studentUpdateApi"

type PayloadShape = Parameters<typeof studentUpdateApi>[0]

export async function studentUpdateService(payload: PayloadShape, token: string) {
	if (payload.update?.studentNo) payload.update.studentNo = +payload.update?.studentNo
	return await studentUpdateApi(payload, token)
}
